import { render, staticRenderFns } from "./RHIdiomaNiveles.vue?vue&type=template&id=1465041b&scoped=true"
import script from "./RHIdiomaNiveles.vue?vue&type=script&lang=js"
export * from "./RHIdiomaNiveles.vue?vue&type=script&lang=js"
import style0 from "./RHIdiomaNiveles.vue?vue&type=style&index=0&id=1465041b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1465041b",
  null
  
)

export default component.exports